import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CueCounter, CuePreparedActivityItem } from 'src/app/models/fincas/cue.model';
import { CueSummaryPresenter } from '../../presenters/cue-summary.presenter';

/** Shows what will be sent to CUE before the user confirms the export. */
@Component({
  selector: 'app-cue-activity-summary',
  templateUrl: './cue-activity-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CueActivitySummaryComponent {
  @Input({ required: true })
  public counter!: CueCounter;

  public get hasPreparedActivities(): boolean {
    return CueSummaryPresenter.pendingTaskCount(this.counter) > 0;
  }

  public get preparedItems(): CuePreparedActivityItem[] {
    return CueSummaryPresenter.preparedItems(this.counter).filter((item) => item.count > 0);
  }

  public get preparedSummary(): string {
    return CueSummaryPresenter.preparedSummary(this.counter);
  }
}
